import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { SchemaService } from '../../services/schema.service';
import { FuelcellService } from 'src/app/project/shared/services/fuelcell.service';
import { FuelcellInfo, SchemaDeviceInfo, SchemaStatusLevel } from '../../interfaces/schema-route-station-info.interface';
import { BrennstoffzellenDetails } from 'src/app/project/shared/interfaces/brennstoffzellen-details';
import { getFuelCellCodeString, getFuelCellSwitchOffReasonString, getFuelCellSwitchOnReasonString, getFuelCellSystemStateString } from 'src/app/project/shared/enums/fuel-cell-status.enum';
@Component({
  selector: 'avs-brennstoffzellen-details',
  templateUrl: './brennstoffzellen-details.component.html',
  styleUrls: ['./brennstoffzellen-details.component.css']
})
export class BrennstoffzellenDetailsComponent {
  public samId?: number;
  public detailObj?: FuelcellInfo;
  /** Systemzustand kommt als Kanal-Status (Ok/Warnung/Fehler) der Schema-Sicht */
  public systemzustand?: SchemaStatusLevel | null;
  public details?: BrennstoffzellenDetails;
  /** Geraetedaten der Brennstoffzelle (Geraetename, Seriennummer, Version), sofern gemeldet */
  public deviceInfo?: SchemaDeviceInfo | null;
  protected readonly getFuelCellSystemStateString = getFuelCellSystemStateString;
  protected readonly getFuelCellSwitchOnReasonString = getFuelCellSwitchOnReasonString;
  protected readonly getFuelCellSwitchOffReasonString = getFuelCellSwitchOffReasonString;
  protected readonly getFuelCellCodeString = getFuelCellCodeString;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
    private fuelcellService: FuelcellService,
    private schemaService: SchemaService,
    private dialogRef: MatDialogRef<BrennstoffzellenDetailsComponent>
  ) { }

  public ngOnInit(): void {
    this.samId = this.data.data.routeStation.samId;
    const routeStationId: string = this.data.data.routeStation.id;
    if (!routeStationId) { return; }
    this.schemaService.getSchemaDeviceInfo(routeStationId).subscribe(schemaInfo => {
      this.detailObj = schemaInfo.fuelcell?.data ?? undefined;
      this.systemzustand = schemaInfo.fuelcell?.cInfo?.status;
      // Der DE-Kanal der Brennstoffzelle kommt aus der Schema-Sicht; ohne Kanal gibt es keine Details.
      const deChannel = schemaInfo.fuelcell?.cInfo?.channel?.de;
      if (deChannel === undefined) { return; }
      this.fuelcellService.getDetails({ id: routeStationId, deChannel }).subscribe(response => {
        this.details = response.statusData ?? undefined;
        this.deviceInfo = response.deviceInfo;
      });
    });
  }

  public getSystemzustandString(systemzustand?: number | null): string {
    if (systemzustand === 0) {
      return 'Ok';
    }
    if (systemzustand === 1) {
      return 'Warnung';
    }
    if (systemzustand != null && systemzustand >= 2) {
      return 'Fehler';
    }
    else return 'k.A.'
  }
  
  /** Displays a flag as Ja/Nein; a value that has not been loaded yet stays neutral. */
  public getJaNeinString(value?: boolean): string {
    if (value === undefined || value === null) {
      return '-';
    }
    return value ? 'Ja' : 'Nein';
  }

  public getArbeitsmodusString(arbeitsmodus: number): string {
    if (arbeitsmodus === 0) {
      return 'Automatik';
    }
    if (arbeitsmodus === 1) {
      return 'Aus';
    }
    else return 'k.A.'
  }
  lastSunday(year: number, month: number) {
    let date = new Date(year, month, 1, 12);
    let weekday = date.getDay();
    let dayDiff = weekday === 0 ? 7 : weekday;
    let lastSunday = date.setDate(date.getDate() - dayDiff);

    return date;
  }

  isCEST(d: Date): boolean {
    let testD = new Date(d);
    let year = testD.getFullYear();
    let startCET: Date = this.lastSunday(year, 3);
    let endCET: Date = this.lastSunday(year, 10);
    return !(startCET < testD && testD > endCET);
  }

  offset(d: Date): string {
    return this.isCEST(d) ? 'UTC+2' : 'UTC+1'
  }


  public onCloseClicked(): void {
    this.dialogRef.close();
  }
}